import React, { Component } from "react";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { Page, Loadable, DataTable, Fab, If } from "components/support";
import { Row, Col } from "react-flexbox-grid";
import Big from "big.js";
import { FormattedNumber } from "react-intl";
import Filter from "./filter/index";
import Graph from "./history-graph";
import { colors, Icon } from "assets";

class StockEntryReportView extends Component {
  downloadButton = () => (
    <Fab
      backgroundColor={colors.button.secondary}
      tooltip="Download"
      icon="file_download"
      options={[
        {
          backgroundColor: colors.secondary.light,
          onClick: () => this.props.presenter.onDownload("csv"),
          iconComponent: (
            <Icon.CsvFile style={{ fill: colors.secondary.dark }} />
          ),
          tooltip: "CSV"
        }
        /*
        {
          backgroundColor: colors.primary.normal,
          onClick: () => this.handleDownloadButton('pdf'),
          icon: icons.svg.pdfFile,
          tooltip: 'PDF'
        },
        */
      ]}
    />
  );

  config = {
    identifier: "uuid",
    columns: [
      {
        accessor: "created_at",
        type: "datetime",
        align: "center",
        Header: "Data"
      },
      {
        accessor: "product_name.name",
        align: "center",
        Header: "Produto",
        sortable: false
      },
      {
        accessor: "amount",
        align: "center",
        Header: "Quantidade de Entrada"
      },
      {
        accessor: "cost_value",
        align: "center",
        Header: "Preço de Compra",
        sortable: false,
        Cell: props => this.parseCostValueField(props.row._original.cost_value)
      },
      {
        accessor: "total_cost_value",
        align: "center",
        Header: "Valor total da Compra",
        sortable: false,
        Cell: props =>
          this.parseTotalCostValueField(
            props.row._original.amount,
            props.row._original.cost_value
          )
      }
    ]
  };

  parseCostValueField = value => (
    <FormattedNumber value={Big(value || 0).div(100)} format="BRL" />
  );

  parseTotalCostValueField = (amount, value) => (
    <FormattedNumber
      value={Big(value || 0)
        .div(100)
        .times(amount)}
      format="BRL"
    />
  );

  render() {
    const { presenter, viewModel } = this.props;
    const {
      loading,
      filters,
      results,
      pagination,
      order,
      productSearchOptions
    } = viewModel;
    return (
      <Page>
        <Row>
          <Col xs={12} sm>
            <Typography type="display1" className="pb-sm">
              Histórico de Entradas de Produto
            </Typography>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Filter
              loading={loading}
              filters={filters}
              productSearchOptions={productSearchOptions}
              onChange={filter => presenter.onFilterChange(filter)}
              onFilter={filter => presenter.onFilterChange(filter)}
              onSelectProduct={product => presenter.onFilterChange({ product })}
            />
          </Col>
        </Row>

        <If test={filters.product && filters.product.uuid}>
          <Row className="mb-md">
            <Col xs={12}>
              <Graph filters={filters} />
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Loadable loading={loading}>
                <Paper elevation={1}>
                  <DataTable
                    manual
                    filterable={false}
                    defaultSorted={[{ id: "created_at", desc: true }]}
                    resultSet={results}
                    total={pagination.total}
                    perPage={pagination.perPage}
                    page={pagination.page}
                    config={this.config}
                    orderField={order.field}
                    orderDirection={order.direction}
                    onPageChange={page => presenter.onChangePage(page + 1)}
                    onChange={({ field, value }) =>
                      presenter.onChangeOrder({ field, direction: value })
                    }
                  />
                </Paper>
              </Loadable>
            </Col>
          </Row>

          {this.downloadButton()}
        </If>
      </Page>
    );
  }
}

export default StockEntryReportView;



// WEBPACK FOOTER //
// ./src/components/app/history/stock-entry-reports/view.jsx